// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"04d95fd1","936":"be95f40c"}[chunkId] + ".chunk.js";
};